import React from 'react';

export const Container: React.FC = ({ children }) => (
  <div className="w-full max-w-full lg:container px-5 md:px-10 grid grid-cols-4 sm:grid-cols-8 lg:grid-cols-12 gap-4 xl:gap-6 divide-gray-30">
    {children}
  </div>
);
